module.exports = __webpack_public_path__ + "img/icon_map_63_off_100.0a711c01.png";